import Themes from "@/models/settings/Themes";
import {Storage} from "@ionic/storage";
import {defineStore} from "pinia";
import {ThemeStoreState} from "@/types/Stores/ThemeStoreState";

export const useThemeStore = defineStore({
    id: "themeStore",
    state: () =>
        ({
            activeTheme: "",
            /*----- persistent storage -----*/
            storage: new Storage({storeName: "themeStore"}),
        }) as ThemeStoreState,
    getters: {
        theme: (state) => state.activeTheme,
    },
    actions: {
        async init() {
            await this.storage.create();
            this.activeTheme = await this.getTheme();
            if (this.activeTheme == null) {
                await this.setTheme("light");
            }
            this.toggleDarkClass(this.activeTheme);
        },
        async getTheme() {
            this.activeTheme = await this.storage.get("theme");
            return this.activeTheme;
        },
        async setTheme(theme: string) {
            this.activeTheme = theme;
            this.toggleDarkClass(theme);
            await this.storage.set("theme", theme);
        },
        async isDarkMode() {
            return this.activeTheme == Themes.DARK;
        },
        toggleDarkClass(theme: string) {
            if (document == null || document.documentElement == null || document.documentElement.classList == null) return;
            document.documentElement.classList.toggle("ion-palette-dark", theme == Themes.DARK);
        },
    },
});
